import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { StatusBar, Style } from '@capacitor/status-bar';
import { LocalStorageService }  from '../providers/localStorage.service';
import { API }                  from '../providers/api';
import { Router }               from '@angular/router';
import { UpdateService } from '../services/update.service';
import { Device }       from '@capacitor/device';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['app.component.scss'],
  })
  export class AppComponent {
    rootPage:any = 'TabsPage';
    userData : any = {}
    DebugMode : boolean;
    diasCheck = 1;
    sugerenciasBadge : number = null;
    plataforma : string = null;
    Configuraciones : any = [];

    versionInstalada = 306; // CAMBIAR EN android/app/build.gradle // version.guard.ts
    constructor(public platform: Platform, 
                private router:Router,
                public api:API,
                private updateService:UpdateService,
                private storage: LocalStorageService,
                ) {
        
        
                StatusBar.setOverlaysWebView({ overlay: false });
                StatusBar.setBackgroundColor({color: '#ffffff'});
                StatusBar.setStyle({ style: Style.Light });
                StatusBar.show();
                
                this.platform.ready().then(async () => {
                    // Obtener info del dispositivo
                    const info = await Device.getInfo();
                    
                    // Determinar si es plataforma web
                    const isWebPlatform = info.platform === 'web';

                    // Detectar si es PWA
                    const isPwa = window.matchMedia('(display-mode: standalone)').matches
                        || (window.navigator as any).standalone === true;

                    if (isWebPlatform) {
                        const params = new URLSearchParams(window.location.search);
                        const token = params.get('token');
                        if (token) {
                        this.loginWithToken(token);
                        }

                        // Si quieres diferenciar entre browser y PWA
                        if (isPwa) {
                        this.plataforma = 'pwa';
                        } else {
                        this.plataforma = 'browser';
                        }
                    } else {
                        this.plataforma = info.platform;
                    }

                    this.storage.getDispositivo().then((response) => {
                        if (response) {
                        this.plataforma = response.plataforma;
                        }
                    });

                    this.checkVersion();
                    this.checkUserLogin();

                    this.platform.resume.subscribe(() => {
                        this.checkVersion();
                        this.checkUserLogin();
                    });
                });

            
            this.updateService.getLoginObservable().subscribe((usuario) =>{
                this.userData = usuario;
                this.storage.setUserData(usuario);
            });

            this.updateService.getSugerenciasObservable().subscribe( (badgesNum) => {
                this.sugerenciasBadge = badgesNum;
            });
            
            this.updateService.getDispositivoObservable().subscribe((dispositivo)=>{
                this.plataforma = dispositivo.plataforma;
            });

            this.storage.getDebugFlag().then((response)=>{
                this.DebugMode =response;
            });

            this.storage.getUserData().then((response)=>{
                this.userData = response;
            });
    }

    async loginWithToken(tokenConsultaOrg:string) {
        
        if (tokenConsultaOrg) {
            const datos = { token: tokenConsultaOrg };
            const response = await this.api.loginUserToken(datos);
            if (response.data) {
                //console.log("Token guardado", response.data.token);
                await this.storage.setToken(response.data.token);
                await this.SetDefaultEspecie();
                this.userData = response.data.usuario;
                this.updateService.loginOk(this.userData);
                await this.storage.setUserData(this.userData);
                
                if (this.userData.appCondiciones=="1") {
                    console.log("Condiciones aceptadas.")
                    await this.SetDefaultEspecie();
                    this.router.navigateByUrl('/tabs', { replaceUrl: true});
                } else {
                    console.log("Condiciones todavía no han sido aceptadas.")
                    this.router.navigate(['legal', { token: response.data.token }]);
                }          
            }  
        } else {
            //console.log("no hay token")
        }
                    
    }

    SetDefaultEspecie():any {
        return this.storage.getEspecieSeleccionada().then(
            (response) => {
                if (!response) { 
                    
                    return this.api.EspeciesHabilitadas()
                    .then(
                        response => {
                            if (Object.keys(response).length>0) {
                                // guardamos datos clinicos por defecto
                                
                                let datosClinicos = { EspecieID: response.data[0].id, EspecieNombre: response.data[0].nombre, Sexo: 'indefinido', Edad:null, Peso:null };
                                this.storage.setDatosClinicos(datosClinicos);
                                this.storage.setEspecieSeleccionada(response.data[0]);
                            }
                        }).catch(error=>{ }
                    );
                    
                }
            }
        );
        
    }

    private checkVersion() {
        return this.api.getConfiguraciones().then(
            (response) => {
                if (response) {
                    this.Configuraciones = response.data;

                    if (this.versionInstalada<this.Configuraciones["VersionMinima"]) {
                        // onsole.log("no puede funcionar");
                        //this.nav.setRoot("Actualizacion");
                        this.router.navigateByUrl('/actualizacion');
                    }
                    
                }
            }
        );
    }

    private checkUserLogin() {
        this.storage.getLastUserCheck().then(
            (ultimoCheck) => {
                if (ultimoCheck!=null) {
                    /*
                    onsole.log("Última comprobación: " + ultimoCheck);
                    onsole.log("Fecha actual: " + Date.now());
                    onsole.log("Diferencia: " + (Date.now()-ultimoCheck));
                    */
                    let diferenciaDias = Date.now()-ultimoCheck;
                    if (diferenciaDias>(this.diasCheck*24*60*60*1000)) {
                    //if (diferenciaDias>(0.0001)) {
                        this.storage.getUserPassword().then(
                            (userPassword) => {
                                if (userPassword!=null) {
                                    this.storage.getUserData().then(
                                        (userData) => {
                                            if (userData!=null) {
                                                let datos = { nif: userData.dniU, password: userPassword};
                                                this.api.loginUser(datos).then(
                                                    (response) => {
                                                        if (response.data!=null && response.data.usuario && response.data.usuario.pagado==1) {
                                                            
                                                            // onsole.log("Usuario login ok");
                                                            // no hay que hacer nada
                                                        } else {
                                                            this.closeSession();
                                                            // onsole.log("Usuario ya no tiene login.")
                                                            // hay que echarlo
                                                        }
                                                        this.storage.setLastUserCheck(Date.now());
                                                    }
                                                );
                                            }
                                        }
                                    );
                                }
                            }
                        );
                    } else {
                        // onsole.log("Han pasado: " + (Date.now()-ultimoCheck)/24/60/60/1000 + " días")
                        // onsole.log("Aún no han pasado " + this.diasCheck + " días");
                    }
                } else {
                    // onsole.log("Todavía no hay login hecho");
                }
            }
        );
    }

    public readUser() {
        return this.storage.getUserData().then(
            (response) => {
                this.userData = response;
            }
        );
    }

    async closeSession() {
        await this.storage.clearKeys();
        this.router.navigate(['/login']);
    }

    public debugMode() {
        this.storage.getDebugFlag().then((response)=>{
            this.storage.setDebugFlag(!response);
        });
    }

    public openPage(page) {
        this.router.navigate([page, {seccion: page}]);        
    }

    openHome() {
        this.router.navigateByUrl('/tabs', { replaceUrl: true});
    }

    public abreAvisoLegal() {
        let url = "http://www.consultavet.org/aviso-legal";
        window.open(url,'_system','location=yes');
    }


    public abreCondicionesUso() {
        let url = "http://app.consultavet.org/condiciones-de-uso";
        window.open(url,'_system','location=yes');
    }

    formatVersion(numero) {

        const arrayNumero = numero.toString().split('');
        let retorno = "";
        arrayNumero.forEach(element => {
            retorno += element +".";
        });
        return retorno;
    }
}
